import { render, staticRenderFns } from "./FactorScoring.vue?vue&type=template&id=6fe7449a&scoped=true&"
import script from "./FactorScoring.vue?vue&type=script&lang=ts&"
export * from "./FactorScoring.vue?vue&type=script&lang=ts&"
import style0 from "./FactorScoring.vue?vue&type=style&index=0&id=6fe7449a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe7449a",
  null
  
)

export default component.exports